import { PagedTable, PagedTableProps } from 'bold-ui'
import { DateTime } from 'components/date'
import { TableBox } from 'components/table/TableBox'
import { LoteHistoricoExportacao } from 'graphql/types.generated'
import { ReactNode } from 'react'

type Item = LoteHistoricoExportacao

type TransmissaoEnvioHistoricoExportTableProps = Omit<PagedTableProps<Item>, 'columns'>

export const TransmissaoEnvioHistoricoExportTable = (props: TransmissaoEnvioHistoricoExportTableProps) => {
  const renderNomeProfissional: (row: Item) => ReactNode = (row) => row.nomeProfissional?.titleCase()
  const renderSalvoEm: (row: Item) => ReactNode = (row) => <DateTime value={row.dataExportacao} />

  return (
    <TableBox>
      <PagedTable<Item>
        columns={[
          { name: 'nomeProfissional', header: 'Salvo por', render: renderNomeProfissional },
          { name: 'salvoEm', header: 'Salvo em', render: renderSalvoEm },
        ]}
        {...props}
      />
    </TableBox>
  )
}
